var map = {
	"./LINK.svg": "ca0c",
	"./LINK_2x.svg": "44dc",
	"./MINIPROGRAM.svg": "90e8",
	"./MINIPROGRAM_2x.svg": "7375",
	"./VIDEO.svg": "096a",
	"./VIDEO_2x.svg": "2ef3",
	"./addition.svg": "8c37",
	"./default_2x.svg": "2333",
	"./delete.svg": "7aa2",
	"./delete_icon.svg": "d78a",
	"./edit_icon.svg": "8e9f",
	"./excel.svg": "5e28",
	"./excel_2x.svg": "c765",
	"./hint.svg": "1888",
	"./kn_nodata.svg": "1909",
	"./loading.svg": "a45a",
	"./material-active.svg": "fa3b",
	"./material.svg": "05d0",
	"./menu_move.svg": "0048",
	"./pdf.svg": "c976",
	"./pdf_2x.svg": "cd05c",
	"./ppt.svg": "cae5",
	"./ppt_2x.svg": "ce76",
	"./review.svg": "959f",
	"./setting.svg": "efa1",
	"./share_icon.svg": "8893",
	"./speech_nodata.svg": "f49e",
	"./strategy-active.svg": "e6fa",
	"./strategy.svg": "38c5",
	"./talk_nodata.svg": "40e2",
	"./task-active.svg": "ea1a",
	"./task.svg": "1df5",
	"./word.svg": "536e",
	"./word_2x.svg": "de56"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c297";